import HTTP from '@/plugins/http';
import validationStatusCode from '@/resources/validation_status_code';

const signIn = async (credentials) => validationStatusCode(
  await HTTP.post('/users/login/', credentials)
);

const signUp = async (user_data) => validationStatusCode(
  await HTTP.post('/users/signup/', user_data)
);

const forgetPassword = async (data) => validationStatusCode(
  await HTTP.post('/users/forget_password/', data)
);

const recoveryPassword = async (data) => validationStatusCode(
  await HTTP.post('/users/reset_password/', data)
);

export default {
  signIn,
  signUp,
  forgetPassword,
  recoveryPassword
}
